export interface User {
  _id: string
  email: string
  name: string
}

export interface Room {
  _id: string
  name: string
  description?: string
  gameType?: string
}

export interface Invitation {
  _id: string
  room: Room
  sender: User
  recipient: User
  role?: string
  status: InvitationStatus
  recipientEmail?: string
  createdAt: string
  updatedAt: string
}

export enum InvitationStatus {
  Pending = 'pending',
  Accepted = 'accepted',
  Rejected = 'rejected'
}

export function isInvitationRecipient(
  invitation: Invitation,
  user?: { _id?: string; id?: string; email?: string } | null,
): boolean {
  if (!user) return false
  const recipientId = String(invitation.recipient?._id || '').trim()
  const userId = String(user._id || user.id || '').trim()
  if (recipientId && userId && recipientId === userId) return true
  const inviteEmail = String(invitation.recipient?.email || invitation.recipientEmail || '')
    .toLowerCase()
    .trim()
  const userEmail = String(user.email || '').toLowerCase().trim()
  return !!inviteEmail && !!userEmail && inviteEmail === userEmail
}
